package com.tedd.db

import app.cash.sqldelight.Query
import app.cash.sqldelight.TransacterImpl
import app.cash.sqldelight.db.QueryResult
import app.cash.sqldelight.db.SqlCursor
import app.cash.sqldelight.db.SqlDriver
import kotlin.Any
import kotlin.Long
import kotlin.String

public class ExpenseListItemQueries(
  driver: SqlDriver,
) : TransacterImpl(driver) {
  public fun <T : Any> selectAll(mapper: (
    id: String,
    list_id: String,
    name: String,
    planned: Long,
    actual_: Long?,
    cat_id: String?,
    is_done: Long,
    order_index: Long,
    created_at: Long,
    updated_at: Long,
    is_deleted: Long,
    deleted_at: Long?,
    synced_at: Long?,
  ) -> T): Query<T> = Query(-859_468_774, arrayOf("expense_list_item"), driver,
      "ExpenseListItem.sq", "selectAll",
      "SELECT expense_list_item.id, expense_list_item.list_id, expense_list_item.name, expense_list_item.planned, expense_list_item.actual, expense_list_item.cat_id, expense_list_item.is_done, expense_list_item.order_index, expense_list_item.created_at, expense_list_item.updated_at, expense_list_item.is_deleted, expense_list_item.deleted_at, expense_list_item.synced_at FROM expense_list_item WHERE is_deleted = 0 ORDER BY list_id, order_index") {
      cursor ->
    mapper(
      cursor.getString(0)!!,
      cursor.getString(1)!!,
      cursor.getString(2)!!,
      cursor.getLong(3)!!,
      cursor.getLong(4),
      cursor.getString(5),
      cursor.getLong(6)!!,
      cursor.getLong(7)!!,
      cursor.getLong(8)!!,
      cursor.getLong(9)!!,
      cursor.getLong(10)!!,
      cursor.getLong(11),
      cursor.getLong(12)
    )
  }

  public fun selectAll(): Query<Expense_list_item> = selectAll { id, list_id, name, planned,
      actual_, cat_id, is_done, order_index, created_at, updated_at, is_deleted, deleted_at,
      synced_at ->
    Expense_list_item(
      id,
      list_id,
      name,
      planned,
      actual_,
      cat_id,
      is_done,
      order_index,
      created_at,
      updated_at,
      is_deleted,
      deleted_at,
      synced_at
    )
  }

  public fun <T : Any> selectByList(list_id: String, mapper: (
    id: String,
    list_id: String,
    name: String,
    planned: Long,
    actual_: Long?,
    cat_id: String?,
    is_done: Long,
    order_index: Long,
    created_at: Long,
    updated_at: Long,
    is_deleted: Long,
    deleted_at: Long?,
    synced_at: Long?,
  ) -> T): Query<T> = SelectByListQuery(list_id) { cursor ->
    mapper(
      cursor.getString(0)!!,
      cursor.getString(1)!!,
      cursor.getString(2)!!,
      cursor.getLong(3)!!,
      cursor.getLong(4),
      cursor.getString(5),
      cursor.getLong(6)!!,
      cursor.getLong(7)!!,
      cursor.getLong(8)!!,
      cursor.getLong(9)!!,
      cursor.getLong(10)!!,
      cursor.getLong(11),
      cursor.getLong(12)
    )
  }

  public fun selectByList(list_id: String): Query<Expense_list_item> = selectByList(list_id) { id,
      list_id_, name, planned, actual_, cat_id, is_done, order_index, created_at, updated_at,
      is_deleted, deleted_at, synced_at ->
    Expense_list_item(
      id,
      list_id_,
      name,
      planned,
      actual_,
      cat_id,
      is_done,
      order_index,
      created_at,
      updated_at,
      is_deleted,
      deleted_at,
      synced_at
    )
  }

  public fun <T : Any> selectById(id: String, mapper: (
    id: String,
    list_id: String,
    name: String,
    planned: Long,
    actual_: Long?,
    cat_id: String?,
    is_done: Long,
    order_index: Long,
    created_at: Long,
    updated_at: Long,
    is_deleted: Long,
    deleted_at: Long?,
    synced_at: Long?,
  ) -> T): Query<T> = SelectByIdQuery(id) { cursor ->
    mapper(
      cursor.getString(0)!!,
      cursor.getString(1)!!,
      cursor.getString(2)!!,
      cursor.getLong(3)!!,
      cursor.getLong(4),
      cursor.getString(5),
      cursor.getLong(6)!!,
      cursor.getLong(7)!!,
      cursor.getLong(8)!!,
      cursor.getLong(9)!!,
      cursor.getLong(10)!!,
      cursor.getLong(11),
      cursor.getLong(12)
    )
  }

  public fun selectById(id: String): Query<Expense_list_item> = selectById(id) { id_, list_id, name,
      planned, actual_, cat_id, is_done, order_index, created_at, updated_at, is_deleted,
      deleted_at, synced_at ->
    Expense_list_item(
      id_,
      list_id,
      name,
      planned,
      actual_,
      cat_id,
      is_done,
      order_index,
      created_at,
      updated_at,
      is_deleted,
      deleted_at,
      synced_at
    )
  }

  public fun <T : Any> selectDirty(mapper: (
    id: String,
    list_id: String,
    name: String,
    planned: Long,
    actual_: Long?,
    cat_id: String?,
    is_done: Long,
    order_index: Long,
    created_at: Long,
    updated_at: Long,
    is_deleted: Long,
    deleted_at: Long?,
    synced_at: Long?,
  ) -> T): Query<T> = Query(-1_313_080_309, arrayOf("expense_list_item"), driver,
      "ExpenseListItem.sq", "selectDirty",
      "SELECT expense_list_item.id, expense_list_item.list_id, expense_list_item.name, expense_list_item.planned, expense_list_item.actual, expense_list_item.cat_id, expense_list_item.is_done, expense_list_item.order_index, expense_list_item.created_at, expense_list_item.updated_at, expense_list_item.is_deleted, expense_list_item.deleted_at, expense_list_item.synced_at FROM expense_list_item WHERE synced_at IS NULL OR synced_at < updated_at") {
      cursor ->
    mapper(
      cursor.getString(0)!!,
      cursor.getString(1)!!,
      cursor.getString(2)!!,
      cursor.getLong(3)!!,
      cursor.getLong(4),
      cursor.getString(5),
      cursor.getLong(6)!!,
      cursor.getLong(7)!!,
      cursor.getLong(8)!!,
      cursor.getLong(9)!!,
      cursor.getLong(10)!!,
      cursor.getLong(11),
      cursor.getLong(12)
    )
  }

  public fun selectDirty(): Query<Expense_list_item> = selectDirty { id, list_id, name, planned,
      actual_, cat_id, is_done, order_index, created_at, updated_at, is_deleted, deleted_at,
      synced_at ->
    Expense_list_item(
      id,
      list_id,
      name,
      planned,
      actual_,
      cat_id,
      is_done,
      order_index,
      created_at,
      updated_at,
      is_deleted,
      deleted_at,
      synced_at
    )
  }

  public fun <T : Any> selectByIdAnyState(id: String, mapper: (
    id: String,
    list_id: String,
    name: String,
    planned: Long,
    actual_: Long?,
    cat_id: String?,
    is_done: Long,
    order_index: Long,
    created_at: Long,
    updated_at: Long,
    is_deleted: Long,
    deleted_at: Long?,
    synced_at: Long?,
  ) -> T): Query<T> = SelectByIdAnyStateQuery(id) { cursor ->
    mapper(
      cursor.getString(0)!!,
      cursor.getString(1)!!,
      cursor.getString(2)!!,
      cursor.getLong(3)!!,
      cursor.getLong(4),
      cursor.getString(5),
      cursor.getLong(6)!!,
      cursor.getLong(7)!!,
      cursor.getLong(8)!!,
      cursor.getLong(9)!!,
      cursor.getLong(10)!!,
      cursor.getLong(11),
      cursor.getLong(12)
    )
  }

  public fun selectByIdAnyState(id: String): Query<Expense_list_item> = selectByIdAnyState(id) {
      id_, list_id, name, planned, actual_, cat_id, is_done, order_index, created_at, updated_at,
      is_deleted, deleted_at, synced_at ->
    Expense_list_item(
      id_,
      list_id,
      name,
      planned,
      actual_,
      cat_id,
      is_done,
      order_index,
      created_at,
      updated_at,
      is_deleted,
      deleted_at,
      synced_at
    )
  }

  public fun insert(
    id: String,
    list_id: String,
    name: String,
    planned: Long,
    actual_: Long?,
    cat_id: String?,
    is_done: Long,
    order_index: Long,
    created_at: Long,
    updated_at: Long,
  ) {
    driver.execute(764_260_804, """
        |INSERT INTO expense_list_item(id, list_id, name, planned, actual, cat_id, is_done, order_index, created_at, updated_at)
        |VALUES (?, ?, ?, ?, ?, ?, ?, ?, ?, ?)
        """.trimMargin(), 10) {
          bindString(0, id)
          bindString(1, list_id)
          bindString(2, name)
          bindLong(3, planned)
          bindLong(4, actual_)
          bindString(5, cat_id)
          bindLong(6, is_done)
          bindLong(7, order_index)
          bindLong(8, created_at)
          bindLong(9, updated_at)
        }
    notifyQueries(764_260_804) { emit ->
      emit("expense_list_item")
    }
  }

  public fun update(
    name: String,
    planned: Long,
    actual_: Long?,
    cat_id: String?,
    is_done: Long,
    order_index: Long,
    updated_at: Long,
    id: String,
  ) {
    driver.execute(1_109_206_996, """
        |UPDATE expense_list_item
        |SET name = ?, planned = ?, actual = ?, cat_id = ?, is_done = ?, order_index = ?, updated_at = ?
        |WHERE id = ?
        """.trimMargin(), 8) {
          bindString(0, name)
          bindLong(1, planned)
          bindLong(2, actual_)
          bindString(3, cat_id)
          bindLong(4, is_done)
          bindLong(5, order_index)
          bindLong(6, updated_at)
          bindString(7, id)
        }
    notifyQueries(1_109_206_996) { emit ->
      emit("expense_list_item")
    }
  }

  public fun setActual(
    actual_: Long?,
    updated_at: Long,
    id: String,
  ) {
    driver.execute(914_993_573,
        """UPDATE expense_list_item SET actual = ?, updated_at = ? WHERE id = ?""", 3) {
          bindLong(0, actual_)
          bindLong(1, updated_at)
          bindString(2, id)
        }
    notifyQueries(914_993_573) { emit ->
      emit("expense_list_item")
    }
  }

  public fun toggleDone(updated_at: Long, id: String) {
    driver.execute(-70_124_927,
        """UPDATE expense_list_item SET is_done = CASE is_done WHEN 1 THEN 0 ELSE 1 END, updated_at = ? WHERE id = ?""",
        2) {
          bindLong(0, updated_at)
          bindString(1, id)
        }
    notifyQueries(-70_124_927) { emit ->
      emit("expense_list_item")
    }
  }

  public fun resetForList(updated_at: Long, list_id: String) {
    driver.execute(-629_730_429,
        """UPDATE expense_list_item SET is_done = 0, actual = NULL, updated_at = ? WHERE list_id = ? AND is_deleted = 0""",
        2) {
          bindLong(0, updated_at)
          bindString(1, list_id)
        }
    notifyQueries(-629_730_429) { emit ->
      emit("expense_list_item")
    }
  }

  public fun softDelete(
    deleted_at: Long?,
    updated_at: Long,
    id: String,
  ) {
    driver.execute(187_207_680,
        """UPDATE expense_list_item SET is_deleted = 1, deleted_at = ?, updated_at = ? WHERE id = ?""",
        3) {
          bindLong(0, deleted_at)
          bindLong(1, updated_at)
          bindString(2, id)
        }
    notifyQueries(187_207_680) { emit ->
      emit("expense_list_item")
    }
  }

  public fun restore(updated_at: Long, id: String) {
    driver.execute(1_357_628_643,
        """UPDATE expense_list_item SET is_deleted = 0, deleted_at = NULL, updated_at = ? WHERE id = ?""",
        2) {
          bindLong(0, updated_at)
          bindString(1, id)
        }
    notifyQueries(1_357_628_643) { emit ->
      emit("expense_list_item")
    }
  }

  public fun hardDelete(id: String) {
    driver.execute(7_145_473, """DELETE FROM expense_list_item WHERE id = ?""", 1) {
          bindString(0, id)
        }
    notifyQueries(7_145_473) { emit ->
      emit("expense_list_item")
    }
  }

  public fun markSynced(
    synced_at: Long?,
    id: String,
    updated_at: Long,
  ) {
    driver.execute(1_390_101_298,
        """UPDATE expense_list_item SET synced_at = ? WHERE id = ? AND updated_at <= ?""", 3) {
          bindLong(0, synced_at)
          bindString(1, id)
          bindLong(2, updated_at)
        }
    notifyQueries(1_390_101_298) { emit ->
      emit("expense_list_item")
    }
  }

  private inner class SelectByListQuery<out T : Any>(
    public val list_id: String,
    mapper: (SqlCursor) -> T,
  ) : Query<T>(mapper) {
    override fun addListener(listener: Query.Listener) {
      driver.addListener("expense_list_item", listener = listener)
    }

    override fun removeListener(listener: Query.Listener) {
      driver.removeListener("expense_list_item", listener = listener)
    }

    override fun <R> execute(mapper: (SqlCursor) -> QueryResult<R>): QueryResult<R> =
        driver.executeQuery(-2_094_408_580,
        """SELECT expense_list_item.id, expense_list_item.list_id, expense_list_item.name, expense_list_item.planned, expense_list_item.actual, expense_list_item.cat_id, expense_list_item.is_done, expense_list_item.order_index, expense_list_item.created_at, expense_list_item.updated_at, expense_list_item.is_deleted, expense_list_item.deleted_at, expense_list_item.synced_at FROM expense_list_item WHERE list_id = ? AND is_deleted = 0 ORDER BY order_index""",
        mapper, 1) {
      bindString(0, list_id)
    }

    override fun toString(): String = "ExpenseListItem.sq:selectByList"
  }

  private inner class SelectByIdQuery<out T : Any>(
    public val id: String,
    mapper: (SqlCursor) -> T,
  ) : Query<T>(mapper) {
    override fun addListener(listener: Query.Listener) {
      driver.addListener("expense_list_item", listener = listener)
    }

    override fun removeListener(listener: Query.Listener) {
      driver.removeListener("expense_list_item", listener = listener)
    }

    override fun <R> execute(mapper: (SqlCursor) -> QueryResult<R>): QueryResult<R> =
        driver.executeQuery(-873_686_919,
        """SELECT expense_list_item.id, expense_list_item.list_id, expense_list_item.name, expense_list_item.planned, expense_list_item.actual, expense_list_item.cat_id, expense_list_item.is_done, expense_list_item.order_index, expense_list_item.created_at, expense_list_item.updated_at, expense_list_item.is_deleted, expense_list_item.deleted_at, expense_list_item.synced_at FROM expense_list_item WHERE id = ? AND is_deleted = 0""",
        mapper, 1) {
      bindString(0, id)
    }

    override fun toString(): String = "ExpenseListItem.sq:selectById"
  }

  private inner class SelectByIdAnyStateQuery<out T : Any>(
    public val id: String,
    mapper: (SqlCursor) -> T,
  ) : Query<T>(mapper) {
    override fun addListener(listener: Query.Listener) {
      driver.addListener("expense_list_item", listener = listener)
    }

    override fun removeListener(listener: Query.Listener) {
      driver.removeListener("expense_list_item", listener = listener)
    }

    override fun <R> execute(mapper: (SqlCursor) -> QueryResult<R>): QueryResult<R> =
        driver.executeQuery(-997_645_922,
        """SELECT expense_list_item.id, expense_list_item.list_id, expense_list_item.name, expense_list_item.planned, expense_list_item.actual, expense_list_item.cat_id, expense_list_item.is_done, expense_list_item.order_index, expense_list_item.created_at, expense_list_item.updated_at, expense_list_item.is_deleted, expense_list_item.deleted_at, expense_list_item.synced_at FROM expense_list_item WHERE id = ?""",
        mapper, 1) {
      bindString(0, id)
    }

    override fun toString(): String = "ExpenseListItem.sq:selectByIdAnyState"
  }
}
